import { defineMessages } from 'react-intl';

export default defineMessages({
    personalIDNumber: {
        id: 'Personal ID number',
        defaultMessage: 'Personal ID number'
    },
    firstAddressLine: {
        id: 'Address Line 1',
        defaultMessage: 'Address Line 1'
    },
    secondAddressLine: {
        id: 'Address Line 2',
        defaultMessage: 'Address Line 2'
    },
    flatNumber: {
        id: 'Flat number',
        defaultMessage: 'Flat number'
    },
    houseNumber: {
        id: 'House number',
        defaultMessage: 'House number'
    },
    postcode: {
        id: 'Postcode',
        defaultMessage: 'Postcode'
    },
    town: {
        id: 'Town',
        defaultMessage: 'Town'
    },
    termsOfUse: {
        id: 'Terms of use',
        defaultMessage: 'Terms of use'
    },
    privacyPolicy: {
        id: 'Privacy Policy',
        defaultMessage: 'Privacy Policy'
    },
    acceptableUsePolicy: {
        id: 'Acceptable Use Policy',
        defaultMessage: 'Acceptable Use Policy'
    },
    personalIncomeBusinessField: {
        id: 'Personal income from business',
        defaultMessage: 'Personal income from business'
    },
    hasOtherIncome: {
        id: 'Do you have any other income?',
        defaultMessage: 'Do you have any other income?'
    },
    hasOtherIncomeSubtext: {
        id: 'e.g. Part-time job, investments, child support or a pension',
        defaultMessage:
            'e.g. Part-time job, investments, child support or a pension'
    },
    monthlyNonBusinessIncome: {
        id: 'Non-business income (per month, after tax)',
        defaultMessage: 'Non-business income (per month, after tax)'
    },
    mainPhoneNumberSubtext: {
        id: "We'll use your phone number to contact you about your application. Don't worry – it won't be shared with anyone else.",
        defaultMessage:
            "We'll use your phone number to contact you about your application. Don't worry – it won't be shared with anyone else."
    },
    streetLineOneQuestionSubtext: {
        id: 'We need your current registered address, as it is printed on your ID card.',
        defaultMessage:
            'We need your current registered address, as it is printed on your ID card.'
    },
    selectPlaceholder: {
        id: 'selectPlaceholder',
        defaultMessage: 'Select...'
    },
    yes: {
        id: 'Yes',
        defaultMessage: 'Yes'
    },
    no: {
        id: 'No',
        defaultMessage: 'No'
    },
    privacyPolicyAndTermsAndConditions: {
        id: 'Privacy policy and terms and conditions',
        defaultMessage:
            'You should accept the privacy policies ({privacyPolicyLink}) and terms and conditions ({termsAndConditionsLink}).'
    },
    businessIncomeSalary: {
        id: 'Business income salary',
        defaultMessage: 'What is your business income (salary)?'
    },
    businessIncomeProfitShare: {
        id: 'Business income profit share',
        defaultMessage: 'What is your business income (profit share)?'
    }
});
